import { Grid, Theme, Viewport } from '@livecontrol/core-ui';
import { DefconCommand } from './defcon';

export const DefconList = ({ webplayerClientId }: { webplayerClientId?: string }): React.ReactElement => {
    const viewport = Theme.useViewport();

    return (
    <div className='font-size-10px'>
        <h1 className='text-white font-size-18px'>Control Panel</h1>
        <Grid gridTemplateColumns='1fr' alignItems='center' gap='10px'>
            <Grid.Item className='mt-12px'>
                <span className='text-white font-size-14px font-weight-bold'>Safe Commands</span>
            </Grid.Item>
            <Grid.KVPairs style={{gridTemplateColumns: viewport === Viewport.XL ? '200px 1fr' : 'minmax(100%, 100px'}}>
                <Grid.Item className='text-white'>
                    <p>
                        Syncs the Web Player with the Asset Service.
                    </p>
                    <p>
                        Syncs Web Player with the Asset Service and sends signal to auto start.
                    </p>
                    <p>
                        Syncs Asset Service with Mux, then triggers &quot;Refresh + Start Signal&quot;
                    </p>
                </Grid.Item>
                <Grid.Item className='d-flex flex-column justify-content-around row-gap-12px'>
                    <DefconCommand
                        command='defconCacheRefresh'
                        title='Are your sure you want to refresh the stream?'
                        content='This action will sync the Web Player with the Asset Service.'
                        webplayerClientId={webplayerClientId}
                        tooltip='Syncs the Web Player with the Asset Service.'
                        cta='Refresh'
                    />
                    <DefconCommand
                        command='defconCacheRefreshAndSignal'
                        title='Are your sure you want to refresh the stream and send auto start signal?'
                        content='This action will sync the Web Player with the Asset Service and send the Start Signal to the Web Player so that the video auto starts.'
                        webplayerClientId={webplayerClientId}
                        tooltip='Syncs Web Player with the Asset Service and sends signal to auto start.'
                        cta='Refresh + Send Signal'
                    />
                    <DefconCommand
                        command='defconNuclearRefresh'
                        title='Are your sure you want to refresh the stream and trigger "Refresh + Start Signal"?'
                        content='This action will take a few seconds to complete as it needs to re-sync Mux’s database with ours, and then trigger the “Refresh + Start Signal” action.'
                        webplayerClientId={webplayerClientId}
                        tooltip='Syncs Asset Service with Mux, then triggers "Refresh + Start Signal".'
                        cta='Refresh + Mux Sync'
                    />
                </Grid.Item>
            </Grid.KVPairs>
            <Grid.Item className='mt-12px'>
                <span className='text-white font-size-14px font-weight-bold'>Danger</span>
            </Grid.Item>
            <Grid.KVPairs style={{gridTemplateColumns: viewport === Viewport.XL ? '200px 1fr' : 'minmax(100%, 100px'}}>

                <p className='text-white'>
                    Forces everyone&apos;s browser to refresh at the same time.
                </p>
                <DefconCommand
                    command='defconForceBrowserRefresh'
                    title="Are your sure you want to force everyone's browser to refresh at the same time?"
                    content='This action will cause the browser of anyone watching our web player to refresh, as if someone had pressed the “Reload button” on their browser.'
                    webplayerClientId={webplayerClientId}
                    tooltip="Forces everyone's browser to refresh at the same time."
                    cta='Browser Refresh'
                />
            </Grid.KVPairs>

            <Grid.Item className='mt-12px'>
                <span className='text-white font-size-14px font-weight-bold'>End Stream</span>
            </Grid.Item>

            <Grid.KVPairs style={{gridTemplateColumns: viewport === Viewport.XL ? '200px 1fr' : 'minmax(100%, 100px'}}>
                <p className='text-white'>
                Ends the stream for everyone.
                </p>
                <DefconCommand
                    command='defconForceEndStream'
                    title='Are your sure you want to end the stream for everyone?'
                    content='This action will stop and end the live stream for everyone.'
                    webplayerClientId={webplayerClientId}
                    tooltip='Ends the stream for everyone.'
                    cta='Force End'
                    variant='danger'
                />
            </Grid.KVPairs>
        </Grid>
    </div>
    );
};
